import service from './service'
const clientList = Symbol('clientList')

class QSDK {
  constructor(auth = {}) {
    this[clientList] = {}
    this.auth = auth
  }
  on(key, fn) {
    if (!this[clientList][key]) {
      this[clientList][key] = []
    }
    this[clientList][key].push(fn)
  }
  off(key, fn) {
    let fns = this[clientList][key]
    if (!fns || fns.length == 0) {
      return false
    }
    if (!fn) {
      fns.length = 0
    } else {
      for (var i = 0, _fn; (_fn = fns[i++]); ) {
        if (fn === _fn) {
          fns.splice(i - 1, 1)
        }
      }
    }
  }
  fire() {
    let key = Array.prototype.shift.call(arguments),
      fns = this[clientList][key]
    if (!fns || fns.length === 0) {
      return false
    }
    for (var i = 0, fn; (fn = fns[i++]); ) {
      fn.apply(this, arguments)
    }
  }
  init() {}
}

Object.assign(QSDK.prototype, service)

export default QSDK
